// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { DatePicker } from 'ant-design-vue';
//import 'ant-design-vue/dist/antd.less';
import 'ant-design-vue/dist/antd.css';
import { Button, message } from 'ant-design-vue';
import Print from 'vue-print-nb'
import JsonExcel from 'vue-json-excel'
import Antd from 'ant-design-vue';
import "echarts";
Vue.component('downloadExcel', JsonExcel)
Vue.use(Print); //注册
Vue.component(Button.name, Button);
Vue.component(Button.Group.name, Button.Group);
Vue.use(DatePicker);
Vue.prototype.$message = message;
Vue.use(Antd);
Vue.use(Button);
Vue.prototype.$message = message;
Vue.config.productionTip = false;

//过滤器
Vue.filter('toPrecent',function(count) {
  return parseFloat((count*100).toPrecision(3))+ "%"
})
Vue.filter('toPrecent2',function(count) {
  return parseFloat(count.toPrecision(3))+ "%"
})
Vue.filter('toHour',function(millisecond) {
  return parseFloat(millisecond/60000)
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js